import { Field, Input, Stack } from "@introist/react-foundation/v2";
import { UpsertFormProps } from "../../foundation";
import { Task } from "./useTasks";

export const TaskForm = ({ value, onChange }: UpsertFormProps<Task>) => {
  return (
    <Stack vertical style={{ width: "400px" }}>
      <Field title="Title">
        <Input
          value={value.title}
          onChange={title => onChange({ ...value, title })}
          autoFocus
          placeholder="E.g. Complete onboarding survey"
        />
      </Field>
    </Stack>
  );
};
